/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Assignment_Email_Skip_ButtonInputs */



/**
* | output |
* | --- |
* | "No thanks" |
*
* @param {Explorer_Assignment_Email_Skip_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_assignment_email_skip_button = /** @type {((inputs?: Explorer_Assignment_Email_Skip_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Assignment_Email_Skip_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Non merci")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nein danke")
	if (locale === "it") return /** @type {LocalizedString} */ ("No, grazie")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нет, спасибо")
	if (locale === "es") return /** @type {LocalizedString} */ ("No, gracias")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("不用了")
	if (locale === "ja") return /** @type {LocalizedString} */ ("送信しない")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नहीं, धन्यवाद")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não, obrigado")
	return /** @type {LocalizedString} */ ("No thanks")
});